module.exports = __webpack_public_path__ + "img/ejemplo-vida-laboral.dca4b70d.svg";